import CoursesItemsService from "@/services/CoursesItemsService";
import ParentService from "@/services/ParentService";
import { UserFactory } from "@/classes/abstractFactory";

function getInitState() {
  return {
    isLessonLoading: false,
    currentCourseId: null,
    courseName: "",
    courseIcon: "",
    teacher: {},
    lessons: [],
    journal: {},
  };
}
class Lesson {
  constructor(rawLesson, index) {
    const { className, label } = this.calcDisplayData(
      rawLesson.status,
      rawLesson.evaluation_result
    );
    this.index = index;
    this.id = rawLesson.id;
    this.status = rawLesson.status;
    this.statusLabel = label;
    this.className = className;
    this.name = rawLesson.name;
    this.isDemo = Boolean(rawLesson.is_demo);
    this.gradeNumber = rawLesson.grade_number || "";
    this.hasMessages = rawLesson.has_messages;
    this.evaluation = rawLesson.evaluation_result || "";
  }

  calcDisplayData(status, rawEvaluation) {
    let evaluation = rawEvaluation ? parseInt(rawEvaluation, 10) : 12;
    evaluation = isNaN(evaluation) ? -1 : evaluation;
    switch (status) {
      case 0:
        return { className: "not-started", label: "" };
      case 1:
        return { className: "in-progress", label: "на вивченні" };
      case 2:
        return { className: "need-check", label: "на перевірці" };
      case 3:
        if (evaluation >= 4) {
          return { className: "finished", label: "зараховано" };
        }
        return { className: "not-confirmed", label: "незадовільно" };
      case 4:
        return { className: "need-rework", label: "треба доробити" };
      default:
        return { className: "not-started", label: "" };
    }
  }
}

const getters = {
  getCourseName: (state) => {
    return state.courseName;
  },
  getCourseIcon: (state) => {
    return state.courseIcon;
  },
  getTeacher: (state) => {
    return state.teacher;
  },
  getJournal: (state) => {
    return state.journal;
  },
  getLessons: (state) => {
    return state.lessons;
  },
  isLessonLoading(state) {
    return state.isLessonLoading;
  },

  getCurrentCourseId: (state) => {
    return state.currentCourseId;
  },
};

const actions = {
  async loadParentLessons({ commit }, { childId, courseId }) {
    commit("setIsLessonLoading", true);
    try {
      const response = await ParentService.getChildCourseLessons(childId, courseId);
      commit("setCourseName", response.data.name);
      commit("setCourseIcon", response.data.icon);
      commit("setTeacher", response.data.teacher || {});
      commit("setCourseId", courseId);
      commit("setLessons", response.data.lessons || []);
    } finally {
      commit("setIsLessonLoading", false);
    }
  },
  async loadLessons({ commit }, payload) {
    commit("setIsLessonLoading", true);
    try {
      const { courseId } = payload;
      const lessonResponse = await CoursesItemsService.getLessons(courseId);
      const lessons = lessonResponse.data.lessons;
      const lessonsNames = lessonResponse.data.schemas;
      const evaluations = lessonResponse.data.lesson_evaluations;
      const teacher = lessonResponse.data.teacher;
      const name = lessonResponse.data.name;
      const icon = lessonResponse.data.icon;

      commit("setCourseName", name);
      commit("setCourseIcon", icon);
      commit("setTeacher", teacher);
      commit("setCourseId", courseId);
      commit("setLessons", lessons);
      commit(
        "TeacherRoomStore/setJournal",
        {
          students: [
            {
              first_name: "",
              last_name: "",
              evaluations,
            },
          ],
          lessons: lessonsNames,
        },
        { root: true }
      );
    } catch (error) {
      console.log(`Get error on load lessons error: ${error}`);
    }
    commit("setIsLessonLoading", false);
  },
};

function createTeacher(rawUser) {
  const builder = UserFactory.getUserBuilder();
  const user = builder
    .setFirstName(rawUser.first_name)
    .setLastName(rawUser.last_name)
    .setEmail(rawUser.email)
    .setUserId(rawUser.id)
    .seRole(rawUser.role)
    .setGrade(rawUser.grade)
    .setGuest(rawUser.guest)
    .build();
  return user;
}

const mutations = {
  resetStore(state) {
    const initState = getInitState();
    Object.keys(initState).forEach((key) => {
      state[key] = initState[key];
    });
  },

  setCourseName(state, courseName) {
    state.courseName = courseName;
  },
  setCourseIcon(state, courseIcon) {
    state.courseIcon = courseIcon || "";
  },
  setTeacher(state, teacher) {
    state.teacher = createTeacher(teacher);
  },
  setCourseId(state, courseId) {
    state.currentCourseId = parseInt(courseId);
  },
  setLessons(state, rawLessons) {
    state.lessons = [...rawLessons]
      .sort((first, second) => {
        const firstOrder = Number.isFinite(first.order)
          ? first.order
          : Number.MAX_SAFE_INTEGER;
        const secondOrder = Number.isFinite(second.order)
          ? second.order
          : Number.MAX_SAFE_INTEGER;
        return firstOrder - secondOrder;
      })
      .map((rawLesson, index) => new Lesson(rawLesson, index));
  },
  setJournal(state, journal) {
    state.journal = journal;
  },
  setIsLessonLoading(state, isLessonLoading) {
    state.isLessonLoading = isLessonLoading;
  },
};

export default {
  namespaced: true,
  state: getInitState(),
  getters,
  actions,
  mutations,
};
